import { useCallback, useState } from 'react'

export interface CarouselState {
  selected: number
  count: number
  next: () => void
  prev: () => void
  atBeginning: boolean
  atEnd: boolean
}

type UseCarouselState = (props: {
  initial: number
  count: number
}) => CarouselState

const useCarouselState: UseCarouselState = ({ initial, count }) => {
  const [selected, setSelected] = useState(initial)

  const next = useCallback(() => {
    setSelected(sel => Math.min(sel + 1, count - 1))
  }, [count])

  const prev = useCallback(() => {
    setSelected(sel => Math.max(sel - 1, 0))
  }, [])

  return {
    selected,
    count,
    next,
    prev,
    atBeginning: selected === 0,
    atEnd: selected === count - 1,
  }
}

export default useCarouselState
